<script setup lang="ts">
import { RouterView } from 'vue-router'
import { ref, provide, nextTick, watch } from 'vue'
import { useI18n } from 'vue-i18n'
// import CN from 'element-plus/lib/locale/lang/zh-cn'
// import EN from 'element-plus/lib/locale/lang/en'

import CN from 'element-plus/es/locale/lang/zh-cn'
import EN from 'element-plus/es/locale/lang/en'
const isRouterActive = ref(true)
provide('reload', () => {
  isRouterActive.value = false
  nextTick(() => {
    isRouterActive.value = true
  })
})
// 切换elementUI语言
const configLang = {
  CN,
  EN
}
const { locale } = useI18n()
let currentLang = ref(locale.value)
watch(locale, (newVal) => {
  currentLang.value = newVal
})
</script>

<template>
  <div style="height: 100%">
    <el-config-provider :locale="configLang[currentLang]" size="small">
      <RouterView v-if="isRouterActive" />
    </el-config-provider>
  </div>
</template>

<style scoped></style>
